import { types } from "../../types/types";
import { finishSpinner, startSpinner } from "../ui/spinner";
import DiscapacidadService from "../../services/DiscapacidadService";
import { handleErrorApi } from "../../helpers/randoms";
import { startAlerta } from "../ui/alertas";
import { ESTADO_SOLICITUD_INTEGRACION } from "../../components/Discapacidad/data/constants";
import { TAMANO_IMAGENES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";

const baseUrl = process.env.REACT_APP_API_URL;

export const clearDiscapacidadReducer = () => ({ type: types.discapacidadClearReducer });

export const setDiscapacidadRoute = (data) => ({ type: types.setDiscapacidadRoute, payload: data });
export const setBreadcrumbCud = (data) => ({ type: types.setBreadcrumbCud, payload: data });

export const setActiveStepDiscapacidad = (step) => ({ type: types.setDiscapacidadStep, payload: step });

export const setAfiliadoSeleccionadoDiscapacidad = (afiliado) => ({ type: types.discapacidadSetAfiliadoSeleccionado, payload: afiliado });
export const cleanAfiliadoSeleccionadoDiscapacidad = () => ({ type: types.discapacidadCleanAfiliadoSeleccionado });

export const setEfectoreleccionadoDiscapacidad = (afiliado) => ({ type: types.discapacidadSetEfectorSeleccionado, payload: afiliado });
export const cleanEfectoreleccionadoDiscapacidad = () => ({ type: types.discapacidadCleanEfectorSeleccionado });

export const cleanSolicitudesDiscapacidadTomadas = () => {
  return { type: types.discapacidadSolicitudesTomadasLimpiar };
};

export const setEstadoSolicitudesDiscapacidad = (estado) => {
  return {
    type: types.discapacidadSetEstadoSolicitudes,
    payload: estado,
  };
};

export const cleanTipoDocumentacionAbm = () => ({ type: types.discapacidadCleanTiposDocumentacionAbm });

export const cleanSolicitudDiscapacidad = () => ({ type: types.discapacidadCleanSolicitudes });

export const cleanSolicitudIntegracionSeleccionada = () => ({ type: types.discapacidadCleanSolicitudSeleccionada });

export const setSolicitudDiscapacidad = (solicitud) => {
  return {
    type: types.discapacidadSetSolicitudSeleccionada,
    payload: solicitud,
  };
};

export const updateSolicitudDiscapacidad = (key, value) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().discapacidad;

    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada };
      solicitudAux[key] = value;
      dispatch({
        type: types.discapacidadUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updateSolicitudDiscapacidadValues = (values) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().discapacidad;

    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada, ...values };
      dispatch({
        type: types.discapacidadUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updateSolicitudDiscapacidadTerapia = (key, value) => {
  return async (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().discapacidad;

    if (solicitudSeleccionada?.integracionTerapia) {
      const newTerapia = solicitudSeleccionada?.integracionTerapia;
      newTerapia[key] = value;

      dispatch({
        type: types.discapacidadUpdateTerapiaSolicitudSeleccionada,
        payload: newTerapia,
      });
    }
  };
};

export const updateSolicitudDiscapacidadTransporte = (key, value) => {
  return async (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().discapacidad;

    if (solicitudSeleccionada?.integracionTransporte) {
      const newTransporte = solicitudSeleccionada?.integracionTransporte;
      newTransporte[key] = value;

      dispatch({
        type: types.discapacidadUpdateTransporteSolicitudSeleccionada,
        payload: newTransporte,
      });
    }
  };
};

export const addPracticaDiscapacidad = (practica) => {
  return { type: types.discapacidadAddPractica, payload: practica };
};

export const deletePracticaDiscapacidad = (id) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().discapacidad.solicitudSeleccionada;
    const practicasAux = practicas.filter(
      (practica) => practica.idCodNom !== id
    );
    dispatch({ type: types.discapacidadSetPracticas, payload: practicasAux });
  };
};

export const setearValorEnPracticaDiscapacidad = (idPractica, key, value) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().discapacidad.solicitudSeleccionada;
    const practicasAux = [...practicas];
    const index = practicasAux.findIndex((p) => p.idCodNom === idPractica);
    if (index >= 0) {
      practicasAux[index][key] = value;
      dispatch({
        type: types.discapacidadSetPracticas,
        payload: practicasAux,
      });
    }
  };
};

// export const getSolicitudesDiscapacidadAuditoria = (
//   idAfiliado,
//   idCodNom,
//   idSolicitud,
//   fechaDesde,
//   fechaHasta,
//   idEstadoSolicitud
// ) => {
//   return async (dispatch) => {
//     try {
//       dispatch(startSpinner());
//       const result = await DiscapacidadService.getSolicitudesAuditoria(
//         idAfiliado,
//         idCodNom,
//         idSolicitud,
//         fechaDesde,
//         fechaHasta,
//         idEstadoSolicitud,
//       );
//       const body = await result.json();
//       if (result.ok) {
//         dispatch({
//           type: types.discapacidadGetSolicitudesSuccess,
//           payload: body,
//         });
//       } else {
//         throw body;
//       }
//       dispatch(finishSpinner());
//     } catch (error) {
//       dispatch(finishSpinner());
//       dispatch({ type: types.discapacidadGetSolicitudesError });
//       handleErrorApi(
//         dispatch,
//         error,
//         "Error al obtener las solicitudes",
//         "Ha ocurrido un error. Intente nuevamente"
//       );
//     }
//   };
// };

// export const getContadoresSolicitudesIntegracion = (
//   idAfiliado,
//   idCodNom,
//   idSolicitud,
//   fechaDesde,
//   fechaHasta) => {
//   return async (dispatch) => {
//     try {
//       dispatch(startSpinner());
//       const result = await DiscapacidadService.getContadoresSolicitudesIntegracion(
//         idAfiliado,
//         idCodNom,
//         idSolicitud,
//         fechaDesde,
//         fechaHasta
//       );
//       const body = await result.json();
//       if (result.ok) {
//         dispatch({
//           type: types.discapacidadGetContadoresSolicitudesSuccess,
//           payload: body,
//         });
//       } else {
//         throw body;
//       }
//       dispatch(finishSpinner());
//     } catch (error) {
//       dispatch(finishSpinner());
//       dispatch({ type: types.discapacidadGetContadoresSolicitudesError });
//       handleErrorApi(
//         dispatch,
//         error,
//         "Error al obtener los contadores",
//         "Ha ocurrido un error. Intente nuevamente"
//       );
//     }
//   };
// };

export const getSolicitudesContadoresGestionIntegracion = (
  idAfiliado,
  idCodNom,
  idSolicitud,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  spinner = true
) => {
  return async (dispatch) => {    
    try {
      spinner&& dispatch(startSpinner());
      const cargarGrilla = idEstadoSolicitud ? true : false;
      await Promise.all([
        cargarGrilla 
          ? 
            DiscapacidadService.getSolicitudesAuditoria(
              idAfiliado,
              idCodNom,
              idSolicitud,
              fechaDesde,
              fechaHasta,
              idEstadoSolicitud,
            )
          :
            null
        ,
        DiscapacidadService.getContadoresSolicitudesIntegracion(
          idAfiliado,
          idCodNom,
          idSolicitud,
          fechaDesde,
          fechaHasta
        )
      ]).then(async([resultComprobantes, resultContadores]) => {      
        const bodyContadores = await resultContadores.json();  
        if (resultContadores.ok) {
          dispatch({
            type: types.discapacidadGetContadoresSolicitudesSuccess,
            payload: bodyContadores,
          });
        } else {
          throw bodyContadores;
        }
        const bodyComprobantes = cargarGrilla ? await resultComprobantes.json() : null;
        if (resultComprobantes?.ok) {
            dispatch({
              type: types.discapacidadGetSolicitudesSuccess,
              payload: bodyComprobantes,
            });
          } else {
            if(cargarGrilla){
              throw bodyComprobantes;
            }
          }          
      })    
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetSolicitudesError });
      dispatch({ type: types.discapacidadGetContadoresSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposPrestacionesDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getTiposPrestaciones();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposPrestacionesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposPrestacionesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de prestaciones",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposSolicitudesDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getTiposSolicitudes();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSubTiposSolicitudesDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getSubTipoSolicitudes();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetSubTiposSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetSubTiposSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposTransporteDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getTiposTransporteDiscapacidad();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposTransportesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposTransportesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de transporte",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postSolicitudDiscapacidad = (
  data,
  nextStep = null,
  // getSolicitudesAuditoria = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = !!data?.idSolicitud
        ? await DiscapacidadService.putSolicitud(data)
        : await DiscapacidadService.postSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            !!data?.idSolicitud
              ? "Solicitud actualizada correctamente"
              : "Solicitud enviada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (!data.idSolicitud) {
          dispatch(updateSolicitudDiscapacidad("idSolicitud", body.idSolicitud));
          // dispatch(updateSolicitud("practicas", []));
        }
        if (nextStep) dispatch(setActiveStepDiscapacidad(nextStep));
        // if (getSolicitudesAuditoria){
        //   const { estadoSolicitudes } = getState().autorizaciones;
        //   dispatch(
        //     getSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
        //   );
        //   dispatch(
        //     getContadoresSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
        //   );
        // }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar solicitud"
          : "Error al enviar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putCancelarSolicitudIntegracion = (
  idSolicitud,
  closeModalAuditar,
  reloadSolicitudesAuditoria,
  // filtros
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.putCancelarSolicitud({ idSolicitud });
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Solicitud cancelada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (closeModalAuditar) closeModalAuditar();
        if (reloadSolicitudesAuditoria) {
          const { estadoSolicitudes } = getState().discapacidad;
          dispatch(
            getSolicitudesContadoresGestionIntegracion(
              null,
              null,
              null,
              null,
              null,
              parseInt(estadoSolicitudes)
            )
          );
        }  
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al cancelar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPracticasDiscapacidad = (
  data,
  nextStep = null,
  enviarSolicitud,
  setRedirect
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.postPracticas(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updateSolicitudDiscapacidad("practicas", body));
        dispatch({
          type: types.autorizacionesGetPracticasSuccess,
          payload: body,
        });
        if (nextStep) dispatch(setActiveStepDiscapacidad(nextStep));
        if (enviarSolicitud) {
          dispatch(cambiarEstadoSolicitudDiscapacidad(
            {
              idSolicitud: data.idSolicitud,
              idEstadoSolicitud: ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION
            },
            setRedirect
          )
          );
        }
        /* if (getSolicitudesAuditoria) {
          const { estadoSolicitudes } = getState().autorizaciones;
          dispatch(
            getSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
          );
          dispatch(
            getContadoresSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
          );
        } */
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putPeriodosDiscapacidad = (
  data,
  closeModal) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.putPeriodos(data);
      const body = await result.json();      
      if (result.ok) {
        dispatch(
          startAlerta(
            "Periodos guardados exitosamente",
            "success",
            "Comando Exitoso"
          )
        );      
        dispatch(updateSolicitudDiscapacidad("periodos", body?.periodos));
        dispatch(updateSolicitudDiscapacidad("practicas", body?.practicas));
        closeModal&& closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar los periodos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const anularPeriodoIntegracion = (idSolicitud, periodo) =>{ 
  return async (dispatch) =>{
    try{
      dispatch(startSpinner())
      const result = await DiscapacidadService.anularPeriodo(idSolicitud, periodo)
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitudDiscapacidad('periodos', body));
        dispatch(startAlerta("Se ha anulado el periodo.", "success"))
      } else {
        throw body;
      }
      dispatch(finishSpinner())
    }catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al anular el periodo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }
};

export const cambiarEstadoSolicitudDiscapacidad = (data, setRedirect, getAuditoria, closeModal, setOpenAlert) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await DiscapacidadService.putEstadoSolicitud(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      const MENSAJES = {
        2: 'Enviada',
        4: 'Enviada',
        5: 'Autorizada',
        6: 'Rechazada'
      }
      const msj = MENSAJES[data.idEstadoSolicitud]
      if (body.idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.AUTORIZADA && !body.emailEnviadoPrestador) {
        if (setOpenAlert) setOpenAlert(true);
      } else {
        dispatch(
          startAlerta(
            `Solicitud ${msj} Exitosamente`,
            "success",
            "Comando Exitoso"
          )
        );
        if (getAuditoria) {
          const { estadoSolicitudes } = getState().discapacidad;
          dispatch(
            getSolicitudesContadoresGestionIntegracion(null, null, null, null, null, parseInt(estadoSolicitudes))
          );
        }
        if (setRedirect) setRedirect(true);
        if (!!closeModal) closeModal();
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//TRACKING SOLICITUD
export const getTrackingSolicitudIntegracion = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await DiscapacidadService.getTrackingSolicitudIntegracion(
        idSolicitud
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.discapacidadGetTrackingSolicitudIntegracionSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.discapacidadGetTrackingSolicitudIntegracionError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//PDF
export const generatePdfPorIdSolicitudIntegracion = (
  idSolicitud,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await DiscapacidadService.generatePdfPorIdSolicitudIntegracion(
        idSolicitud,
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        window.open(URL.createObjectURL(blob));
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

//TIPO DOCUMENTACION
export const getAllTiposDocumentacionIntegracion = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getAllTiposDocumentacionIntegracion();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const guardarTipoDocumentacionIntegracion = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = data.idTipoDoc 
        ? await DiscapacidadService.putTipoDocumentacionIntegracion(data)
        : await DiscapacidadService.postTipoDocumentacionIntegracion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: data.idTipoDoc 
            ? types.discapacidadPutTiposDocumentacion 
            : types.discapacidadPostTiposDocumentacion,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar tipo de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTipoDocumentacionIntegracion = (id, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.deleteTipoDocumentacionIntegracion(id);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadDeleteTiposDocumentacion,
          payload: id,
        });
        dispatch(
          startAlerta(
            "Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar tipo de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//TIPO DOCUMENTACION SOLICITUD
export const getTiposDocumentacionSolicitudIntegracion = (idTipoSolicitud) => {
  return async (dispatch) => {
    try {
      debugger
      dispatch(startSpinner());
      const result = await DiscapacidadService.getTiposDocumentacionSolicitudIntegracion(idTipoSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getAllTiposDocumentacionSolicitudIntegracion = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getAllTiposDocumentacionSolicitudIntegracion();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposDocumentacionSuccessAbm,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposDocumentacionErrorAbm });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const guardarTipoDocumentacionSolicitudIntegracion = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = data.idTipoDocSolicitud 
        ? await DiscapacidadService.putTipoDocumentacionSolicitudIntegracion(data)
        : await DiscapacidadService.postTipoDocumentacionSolicitudIntegracion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: data.idTipoDocSolicitud 
            ? types.discapacidadPutTiposDocumentacionAbm
            : types.discapacidadPostTiposDocumentacionAbm,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar tipo de documentación solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTipoDocumentacionSolicitudIntegracion = (id, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.deleteTipoDocumentacionSolicitudIntegracion(id);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadDeleteTiposDocumentacionAbm,
          payload: id,
        });
        dispatch(
          startAlerta(
            "Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//TIPO DOCUMENTACION AFILIADO
export const getAllTiposDocumentacionAfiliadoIntegracion = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getAllTiposDocumentacionAfiliadoIntegracion();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposDocumentacionSuccessAbm,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposDocumentacionErrorAbm });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const guardarTipoDocumentacionAfiliadoIntegracion = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = data.idTipoDocAfiliado 
        ? await DiscapacidadService.putTipoDocumentacionAfiliadoIntegracion(data)
        : await DiscapacidadService.postTipoDocumentacionAfiliadoIntegracion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: data.idTipoDocAfiliado 
            ? types.discapacidadPutTiposDocumentacionAbm
            : types.discapacidadPostTiposDocumentacionAbm,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar tipo de documentación afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTipoDocumentacionAfiliadoIntegracion = (id, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.deleteTipoDocumentacionAfiliadoIntegracion(id);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadDeleteTiposDocumentacionAbm,
          payload: id,
        });
        dispatch(
          startAlerta(
            "Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//DOCUMENTACION SOLICITUD
export const getDocumentacionSolicitudIntegracion = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getDocumentacionSolicitudIntegracion(idSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionSolicitudIntegracion = (idSolicitud, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.deleteDocumentacionSolicitudIntegracion(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionSolicitudIntegracion(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoSolicitudIntegracionHandler = (idSolicitud, idTipoDocumento, file,autogestion) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);
      dispatch(uploadArchivoSolicitudIntegracion(formData, idSolicitud, idTipoDocumento,autogestion));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoSolicitudIntegracion = (formData, idSolicitud, idTipoDocumento,autogestion) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
      `${baseUrl}/FileUpload/UploadFileDocumentacionSolicitudIntegracion/${idSolicitud}/${idTipoDocumento}?autogestion=${autogestion}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionSolicitudIntegracion(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

//DOCUMENTACION AFILIADO
export const getDocumentacionAfiliadoIntegracion = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getDocumentacionAfiliadoIntegracion(idAfiliado);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetDocumentacionAfiliadoSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetDocumentacionAfiliadoError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionAfiliadoIntegracion = (idAfiliado, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.deleteDocumentacionAfiliadoIntegracion(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionAfiliadoIntegracion(idAfiliado));
        dispatch(
          startAlerta(
            "Archivo Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoAfiliadoIntegracionHandler = (idAfiliado, idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoAfiliadoIntegracion(formData, idAfiliado, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoAfiliadoIntegracion = (formData, idAfiliado, idTipoDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionAfiliadoIntegracion/${idAfiliado}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionAfiliadoIntegracion(idAfiliado));
        dispatch(
          startAlerta(
            "Archivo Guardado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};


//SOLICITUDES TOMADAS
export const getSolicitudesDiscapacidadTomadasPorUsuario = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result =
        await DiscapacidadService.getSolicitudesTomadasPorUsuario();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadSolicitudesTomadasUsuarioSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.discapacidadSolicitudesTomadasUsuarioError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas por Usuario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesDiscapacidadTomadas = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.getSolicitudesTomadas();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadSolicitudesTomadasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.discapacidadSolicitudesTomadasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putLiberarSolicitudDiscapacidad = (itemTomado, userType, fromHomeScreen, setOpenAlert, item, 
  setOpenModalAuditar, closeModal, reload, filtros) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.putLiberarSolicitud(itemTomado.id);
      const body = await result.json();
      if (result.ok) {        
        if (userType === "currentUser") {
          dispatch({
            type: types.discapacidadSolicitudesTomadasUsuarioLiberar,
            payload: itemTomado.id,
          });          
          dispatch({
            type: types.discapacidadSolicitudesDesmarcarLiberada,
            payload: { idSolicitud: itemTomado.idSolicitud },
          });
          if (fromHomeScreen) {
            setOpenAlert(false);
            dispatch(postTomarSolicitudDiscapacidad(item, setOpenModalAuditar))
          }
          if (reload){
            const { estadoComprobantes } = getState().discapacidad;
            dispatch(
              getSolicitudesContadoresGestionIntegracion(
                filtros?.idAfiliado, 
                filtros?.idCodNom,
                filtros?.idSolicitud,
                filtros?.fechaDesde, 
                filtros?.fechaHasta,
                parseInt(estadoComprobantes)),
                false
            );
          }
          if (!!closeModal) closeModal();
        }
        else if (userType === "allUsers")
          dispatch({
            type: types.discapacidadSolicitudesTomadasLiberar,
            payload: itemTomado.id,
          });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTomarSolicitudDiscapacidad = (solicitud, setOpenModalAuditar) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.postTomarSolicitud(
        solicitud.idSolicitud
      );
      const body = await result.json();
      if (result.ok) {
        if (body.idSolicitud !== 0) {
          dispatch({
            type: types.discapacidadSolicitudesTomadasUsuarioAgregar,
            payload: body,
          });
          dispatch({
            type: types.discapacidadSolicitudesMarcarTomada,
            payload: { solicitud, auth: getState().auth, id: body.id },
          });
          setOpenModalAuditar(true);
          const nuevoItem = {
            ...solicitud, 
            solicitudesIntegracionTomadas: solicitud.solicitudesIntegracionTomadas.length > 0
              ? solicitud.solicitudesIntegracionTomadas
              : [{...body}]
          }
          dispatch(setSolicitudDiscapacidad(nuevoItem));
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//FORMULARIO CUD
export const getFormularioCud = (idAfiliado, notShowMsj = false) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      // dispatch(certificadosTraerStart());
      const result = await DiscapacidadService.getFormularioCud(idAfiliado);
      if (result.status === 204) {
        dispatch({
          type: types.discapacidadSetFormularioCudSuccess,
          payload: null,
        });
      } else {
        const body = await result.json();
        if (result.ok) {
          dispatch({
            type: types.discapacidadSetFormularioCudSuccess,
            payload: body,
          });
          if (!notShowMsj) {
            dispatch(
              startAlerta(
                "Formulario cargado correctamente",
                "success",
                "Comando Exitoso"
              )
            );
          }
        } else {
          throw body;
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al cargado el formulario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }
}


export const postFormularioCud = (
  data,
  existe
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = existe
        ? await DiscapacidadService.putFormularioCud(data)
        : await DiscapacidadService.postFormularioCud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadSetFormularioCudSuccess,
          payload: body,
        });
        dispatch(
          startAlerta(
            existe
              ? "Formulario actualizado correctamente"
              : "Formulario generado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        existe
          ? "Error al actualizar el formulario"
          : "Error al generar el formulario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//NOTAS SOLICITUD
export const getNotasPorSolicitudIntegracion = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await DiscapacidadService.getNotas(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.discapacidadGetNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.discapacidadGetNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const postNotasIntegracion = (data, idSolicitud, method, closeModalHandler, continuarConDevolucion,
  idEstadoSolicitud, closeModalAuditar) => {
  return async (dispatch) => {
    try {
      
      dispatch(startSpinner());
      const result = await DiscapacidadService.postNota(data, method);
      const body = await result.json();
      if (result.ok) {
        if (idEstadoSolicitud) {
          dispatch(cambiarEstadoSolicitudDiscapacidad({
            idSolicitud: idSolicitud,
            idEstadoSolicitud: idEstadoSolicitud
          }, null,null,closeModalAuditar));
          
        } else {
          dispatch(
            startAlerta(
              "Datos Guardados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(getNotasPorSolicitudIntegracion(idSolicitud));
        }
      } else {
        throw body;
      }
      if (closeModalHandler) closeModalHandler();
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las notas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteNotaIntegracion = (idNota, idSolicitud, closeModalDelete) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await DiscapacidadService.deleteNota({ idNota });
      const body = await result.json();
      if (result.ok) {
        dispatch(getNotasPorSolicitudIntegracion(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
      if (closeModalDelete) closeModalDelete();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getConsumosAfiliadosDisca = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await DiscapacidadService.getConsumosAfiliados(idAfiliado);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.discapacidadGetConsumosAfiliadosSuccess,
        payload: body,
      });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al traer los consumos.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};